import { alertCirclePath, arrowDownPath, arrowLeftPath, arrowRightPath, arrowUpPath, calendarPath, checkCirclePath, checkPath, chevronDownPath, chevronLeftPath, chevronRightPath, chevronUpPath, clockPath, closeCirclePath, closePath, copyPath, downloadPath, editPath, errorPath, externalLinkPath, eyePath, filterPath, formPath, gearPath, heartPath, infoPath, languagePath, loadingPath, lockPath, mailPath, menuPath, minusPath, moreVerticalPath, morePath, organizationPath, plusPath, refreshPath, searchPath, sortPath, starFilledPath, starPath, translatePath, trashPath, treePath, uploadPath, userPath, warningPath } from './icons/index.js'

export const iconRegistry = {
  'alert-circle': alertCirclePath,
  'arrow-down': arrowDownPath,
  'arrow-left': arrowLeftPath,
  'arrow-right': arrowRightPath,
  'arrow-up': arrowUpPath,
  'calendar': calendarPath,
  'check-circle': checkCirclePath,
  'check': checkPath,
  'chevron-down': chevronDownPath,
  'chevron-left': chevronLeftPath,
  'chevron-right': chevronRightPath,
  'chevron-up': chevronUpPath,
  'clock': clockPath,
  'close-circle': closeCirclePath,
  'close': closePath,
  'copy': copyPath,
  'download': downloadPath,
  'edit': editPath,
  'error': errorPath,
  'external-link': externalLinkPath,
  'eye': eyePath,
  'filter': filterPath,
  'form': formPath,
  'gear': gearPath,
  'heart': heartPath,
  'info': infoPath,
  'language': languagePath,
  'loading': loadingPath,
  'lock': lockPath,
  'mail': mailPath,
  'menu': menuPath,
  'minus': minusPath,
  'more-vertical': moreVerticalPath,
  'more': morePath,
  'organization': organizationPath,
  'plus': plusPath,
  'refresh': refreshPath,
  'search': searchPath,
  'sort': sortPath,
  'star-filled': starFilledPath,
  'star': starPath,
  'translate': translatePath,
  'trash': trashPath,
  'tree': treePath,
  'upload': uploadPath,
  'user': userPath,
  'warning': warningPath,
} as const

export type IconName = keyof typeof iconRegistry

export const iconNames: readonly IconName[] = [
  "alert-circle",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-up",
  "calendar",
  "check-circle",
  "check",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "clock",
  "close-circle",
  "close",
  "copy",
  "download",
  "edit",
  "error",
  "external-link",
  "eye",
  "filter",
  "form",
  "gear",
  "heart",
  "info",
  "language",
  "loading",
  "lock",
  "mail",
  "menu",
  "minus",
  "more-vertical",
  "more",
  "organization",
  "plus",
  "refresh",
  "search",
  "sort",
  "star-filled",
  "star",
  "translate",
  "trash",
  "tree",
  "upload",
  "user",
  "warning"
] as const
